module.exports = __webpack_public_path__ + "static/img/fazhi.f4ea0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fazhi.png
// module id = L6iR
// module chunks = 1